import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import Config from 'conf';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { GoogleLogin, GoogleLogout } from 'react-google-login';
import { withStyles } from '@material-ui/core';
import { Logger } from 'data/common';
import WaitingLayout from './component/WaitingLayout';
import { apiAuthProvider } from './actions';

function getUrlParams(search) {
    let hashes = search.slice(search.indexOf('?') + 1).split('&');
    return hashes.reduce((params, hash) => {
        let [key, val] = hash.split('=');
        return Object.assign(params, { [key]: decodeURIComponent(val) });
    }, {});
}

class Login extends Component {
    static propTypes = {
        apiAuthProvider: PropTypes.func.isRequired,
        initialized: PropTypes.bool.isRequired,
        classes: PropTypes.object.isRequired
    };

    state = {
        logged: false,
        errorMsg: null
    };

    componentDidMount() {
        const { apiAuthProvider, initialized } = this.props;
        const { logged } = this.state;
        let url = window.location.hash;
        let hash = url.substring(url.indexOf('#') + 1);
        let params = getUrlParams(hash);

        if (logged) {
            document.location.reload();
        }

        let googleToken = params.id_token;
        if (googleToken) {
            apiAuthProvider(googleToken, 'google')
                .then(() => {
                    Logger.log('Connecté');
                    document.location.reload();
                })
                .catch(e => {
                    this.errorDisplay(e);
                });
        } else if (this.GoogleLoginButton !== null && this.GoogleLogoutButton !== null) {
            setTimeout(() => {
                if (initialized) this.GoogleLogoutButton.signOut();
                this.GoogleLoginButton.signIn();
            }, 1000);
        }
    }

    // Affiche les erreurs sous le bouton de connexion Google
    errorDisplay = e => {
        if (e.message) {
            this.setState({
                errorMsg: e.message
            });
        } else if (e.error) {
            this.setState({
                errorMsg: e.error
            });
        } else {
            this.setState({
                errorMsg: e
            });
        }
    };

    onLogin = result => {
        const { apiAuthProvider } = this.props;
        apiAuthProvider(result.code, 'google', 'web')
            .then(result => {
                Logger.log('Connecté', result.code);
                document.location.reload();
            })
            .catch(e => {
                this.onFailLogin(e);
            });
    };

    onFailLogin = e => {
        this.GoogleLogoutButton.signOut();
        this.errorDisplay(e);
        Logger.log('Catch Google Login : ', e);
    };

    render() {
        const { logged, errorMsg } = this.state;
        const { classes } = this.props;
        let message;
        let googleButtonClass;

        // Affiche le message d'erreur s'il existe
        if (errorMsg) {
            message = <div className={classes.errorLoginMessage}>{Translator.translate(`login.${errorMsg}`)}</div>;
        } else {
            message = null;
        }

        // Affiche le bouton de connexion google seulement si non connecté
        if (logged) {
            googleButtonClass = `${classes.btnGoogleDisabled} ${classes.btnGoogle}`;
        } else {
            googleButtonClass = `${classes.btnGoogleEnabled} ${classes.btnGoogle}`;
        }

        // Redirection par défaut pour la connexion google - Popup si Electron !
        let uxMode = 'redirect';
        if (window && window.process && window.process.type !== undefined) uxMode = 'popup';

        return (
            <WaitingLayout>
                <Fragment>
                    <GoogleLogin
                        className={googleButtonClass}
                        clientId={Config.googleApi.clientIdWeb}
                        buttonText={Translator.translate('login.googleButtonText')}
                        accessType="offline"
                        responseType="code"
                        onSuccess={this.onLogin}
                        onFailure={this.onFailLogin}
                        scope="profile email"
                        ref={ref => (this.GoogleLoginButton = ref)}
                        uxMode={uxMode}
                    />

                    <div className={classes.btnGoogleDisconnectDisabled}>
                        <GoogleLogout
                            disabled
                            clientId={Config.googleApi.clientIdWeb}
                            buttonText={Translator.translate('login.googleDisconnectButtonText')}
                            onLogoutSuccess={() => Logger.log('Déconnecté de google')}
                            onFailure={e => {
                                Logger.error(e.message);
                            }}
                            ref={ref => (this.GoogleLogoutButton = ref)}
                        />
                    </div>

                    {message}
                </Fragment>
            </WaitingLayout>
        );
    }
}

function mapStateToProps(state) {
    return {
        initialized: state.data.initialized
    };
}

const styles = theme => ({
    errorLoginMessage: {
        padding: 5,
        maxWidth: '100%',
        width: 400,
        textAlign: 'center',
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText,
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius
    },
    btnGoogleDisconnectDisabled: {
        display: 'none'
    },
    btnGoogleDisabled: { visibility: 'hidden' },
    btnGoogleEnabled: { visibility: 'visible' },
    btnGoogle: {
        maxWidth: '100vw',
        minWidth: 400,
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            maxWidth: '100vw',
            minWidth: '100%',
            marginRight: 20,
            marginLeft: 20,
            alignItems: 'center',
            justifyContent: 'center'
        }
    }
});

module.exports = withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ apiAuthProvider }, dispatch)
    )(withStyles(styles, { withTheme: true })(Login))
);



// WEBPACK FOOTER //
// ./scenes/Login/web.js